module.exports = __webpack_public_path__ + "static/media/resume-icon.ca617ee7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resume-icon.svg
// module id = 1749
// module chunks = 0